<template>
  <modal
    v-model="isActive"
    variant="drawer-no-scroll"
    no-footer
  >
    <template #default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>

    <template #body="{ deactivate, updateFocusable, getFocusableElements }">
      <generic-list
        :items="items"
        :deactivate="deactivate"
        @update-focusable="updateFocusable"
        @get-focusable-elements="getFocusableElements"
      />
    </template>
  </modal>
</template>

<script>
  import { mapState } from 'vuex'
  import GenericList from './components/generic-list/generic-list.vue'

  export default {
    name: 'GenericSearch',
    components: {
      GenericList
    },
    provide() {
      return {
        searchPlaceholder: this.searchPlaceholder || 'Search',
        allLabel: this.allLabel || 'All',
        filterByCategory: this.filterByCategory || 'Filter by category'
      }
    },
    props: {
      searchPlaceholder: {
        type: String
      },
      allLabel: {
        type: String
      },
      filterByCategory: {
        type: String
      },
      items: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        isActive: undefined
      }
    },
    watch: {
      isActive(newVal, oldVal) {
        if (newVal === true) {
          this.$track({ event: 'initiateSearch' })
        }
        if (newVal === false && oldVal === true) {
          this.$track({ event: 'finishSearch' })
        }
      }
    },
    computed: {
      ...mapState('global', ['lang']),
      ...mapState('responsive', ['check'])
    }
  }
</script>
